import { render, staticRenderFns } from "./NewLeadForm.vue?vue&type=template&id=8653af36&scoped=true&"
import script from "./NewLeadForm.vue?vue&type=script&lang=js&"
export * from "./NewLeadForm.vue?vue&type=script&lang=js&"
import style0 from "./NewLeadForm.vue?vue&type=style&index=0&id=8653af36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8653af36",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
